var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"main-panel"},[_c('dashboard-content',{on:{"click":_vm.toggleSidebar}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }